var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5944 0.67229C11.3595 0.228968 12.3555 0.334747 13.0104 0.989625C13.6653 1.6445 13.771 2.64055 13.3277 3.40564L10.5944 0.67229ZM9.78363 1.388L2.05596 9.11568L4.88433 11.944L12.612 4.21637L9.78363 1.388ZM0.989773 13.0104L1.4836 9.68814L4.31197 12.5165L0.989773 13.0104Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/penIcon.85d550fb0b3043bafb7c00df4ad638ea.svg";
export { ForwardRef as ReactComponent };